import PartnerNetwork from '../../modules/PartnerNetwork/PartnerNetwork.jsx';

function PagePartnerNetwork() {
    return <PartnerNetwork />;
}

export default PagePartnerNetwork;
